module.exports = "/call-frontend/img/signup-behind.59c0db49.png";